import { diggingAjax } from '../ajax/DiggingAjax'
import { store } from '../state/store'
import type { ActionResponse } from '../DTOs/Common/ErrorResponse'
import { TruckLoadDTO } from '../DTOs/Production/TruckLoadDTO'
import type { TruckLoadMutationResultDTO } from '../DTOs/Production/TruckLoadMutationResultDTO'
import { computeShiftId } from './computeShiftId'
import { enqueue } from './queueOps'
import { v4 as uuidv4 } from 'uuid'

function currentShiftId(): number {
  const { selectedDate, selectedShift } = store.getState().shift
  return computeShiftId(selectedDate, selectedShift)
}

export const loadingsMutations = {
  async insertTruckLoad(dto: TruckLoadDTO) {
    if (navigator.onLine) return diggingAjax.insertTruckLoad(dto)
    const tempId = uuidv4()
    await enqueue({
      entity: 'loading',
      operation: 'create',
      shiftId: currentShiftId(),
      tempId,
      data: { ...dto },
    })
    const optimisticLoad = new TruckLoadDTO({ ...dto, loadingId: -(Date.now()) })
    return {
      success: true,
      data: { truckLoad: optimisticLoad, currentHourTotalLoads: 0, shiftTotalLoads: 0 } as TruckLoadMutationResultDTO | null,
    }
  },

  async updateTruckLoad(dto: TruckLoadDTO) {
    if (navigator.onLine) return diggingAjax.updateTruckLoad(dto)
    await enqueue({
      entity: 'loading',
      operation: 'update',
      shiftId: currentShiftId(),
      entityId: dto.loadingId,
      rowVersion: dto.rowVersion,
      data: { ...dto },
    })
    return {
      success: true,
      data: { truckLoad: dto, currentHourTotalLoads: 0, shiftTotalLoads: 0 } as TruckLoadMutationResultDTO | null,
    }
  },

  async deleteTruckLoad(loadingId: number, rowVersion?: string) {
    if (navigator.onLine) return diggingAjax.deleteTruckLoad(loadingId)
    await enqueue({
      entity: 'loading',
      operation: 'delete',
      shiftId: currentShiftId(),
      entityId: loadingId,
      rowVersion,
    })
    return {
      success: true,
      data: { truckLoad: null, currentHourTotalLoads: 0, shiftTotalLoads: 0 } as TruckLoadMutationResultDTO | null,
    }
  },
}
